import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Button, LayoutAside, PageHeader, PageSection, RelatedArticlesSection, SvgIcon } from '@gik/ui';
import WishlistHeader from '@gik/wishlist-page/components/WishlistHeader';
import WishlistGrid from './WishlistGrid';
import WishlistPageHeader from './WishlistPageHeader';
import { useInkind } from '@gik/api/inkinds/inkind';
import Link from '@/components/Link';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';

interface IWishlistPageProps {
  inkindRouteId: string;
}

export default function WishlistPage({ inkindRouteId }: IWishlistPageProps): React.ReactElement {
  const bem = bemBlock('wishlist-page');
  const { t } = useTranslation();

  const { data: inkindPage } = useInkind(inkindRouteId);

  return (
    <div className={bem()}>
      <PageHeader variant="aqua">
        <WishlistPageHeader inkindRouteId={inkindRouteId} />
        <Link href={inkindPage?.url}>
          <Button variant="primary-inverted" pill size="sm" prepend={<SvgIcon name="ChevronLeft" size="sm" />}>
            {t(translationKeys.backToPage)}
          </Button>
        </Link>
      </PageHeader>

      {/* TODO: extract aside width and gutter width */}
      <PageSection>
        <LayoutAside asideWidth="310px" gutter="2rem" className={bem('layout')}>
          <main>
            <WishlistHeader inkindRouteId={inkindRouteId} className="main-header" />
            <WishlistGrid inkindRouteId={inkindRouteId} isFullWishlistPage={true} />
          </main>
          <aside>
            <RelatedArticlesSection inkindRouteId={inkindRouteId} />
          </aside>
        </LayoutAside>
      </PageSection>
    </div>
  );
}
